import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";
import {MaterialReactTable} from 'material-react-table';
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {

  MenuItem,
} from '@mui/material';


const CustomerQualityReports = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  let customer_id = localStorage.getItem("customer_id");
  let season_id = localStorage.getItem("season_id");
  
  const formData = ({
    customer:customer_id,  
    season_id:season_id,    
  });
  useEffect(() => {
    console.log(data);
    axios.post("/customerportal/quality-reports/listings",formData,{  headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },})
         .then((response) => {
          
           if (response.data.code === 200) {
            setData(response.data.data.reports);
           }
           else  if (response.data.code === 401) {
            // window.location.href = "/customerportal/login";
           }else{
           //  window.location.href = "/customerportal/login"; 
           }
         })
         .catch((error) => {
           console.log(error);
         });
  }, []);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  console.log(data);


  const PONumberCell = ({ row }) => {
    return (
      <a href={`/customerportal/quality-reports-view/${row.original.id}`} className="">
        {row.original.order_name}
      </a>
    );
  };
  
  PONumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        order_name: PropTypes.string.isRequired,
       
      }).isRequired,
    }).isRequired,
  };
  
  const columns =
  [
      {
        header: 'Order PO Number',
        accessorFn: (row) => `${row.order_name}`,
        Cell: PONumberCell, // ✅ Use the separate component    
      },
    
     {
      accessorKey: 'customer', //normal accessorKey
      header: 'Customer',
    },
    {
      accessorKey: 'sender', //normal accessorKey
      header: 'Sender',
    },
    {
      accessorKey: 'loading_type', //normal accessorKey
      header: 'Loading Type',
    },
  
    {
      accessorKey: 'container_number', //normal accessorKey
      header: 'Container Number',
    },
  
    {
      accessorKey: 'product', //normal accessorKey
      header: 'Product',
    },
  
    {
      accessorKey: 'ref', //normal accessorKey
      header: 'REF',
    },

   ];

  const FichedePalletePDF = async (id) => {
    $("#loader-image1").removeClass('loader-hide');
    $("#loader-image1").addClass('loader-show');
    axios.get(`/quality-report/pdf/${id}`, {
      responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
  }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let file_name = 'QUALITY REPORT.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image1").addClass('loader-hide');
        $("#loader-image1").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });

  };
  
  
  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Quality Reports</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                  <Link to="/customerportal/profile">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Quality Reports</li>
                </ul>
              </div>
              
            </div>
          </div>
 
          <div className="row">
            
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                  <MaterialReactTable columns={columns} data={data} 
                    // enableColumnFilterModes
                    enableColumnOrdering
                    enablePinning
                          enableRowActions
                          //renderColumnActionsMenuItems 
                        // enableRowActions
                          //renderColumnActionsMenuItems 
                            renderRowActionMenuItems={({ row }) => [
                              <MenuItem key="view" onClick={() => FichedePalletePDF(row.original.id)}>
                                Download <img  id={`loader-image1`} className="loader-image loader-hide" src={loader_image}/> 
                              </MenuItem>
                          ]}
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerQualityReports;
